// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__2Jo9M","col":"styles_col__16NWV","fulfillmentStatus":"styles_fulfillmentStatus__2oHCH","emailCol":"styles_emailCol__2OU9Y"};